import { render, staticRenderFns } from "./PlacePicker.vue?vue&type=template&id=65fc0fda"
import script from "./PlacePicker.vue?vue&type=script&lang=ts"
export * from "./PlacePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports